import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import quotation from 'src/repositories/quotation';
import { API_KEY } from 'src/constants/apiKey';

const useSettingShowProducts = () => {
  const querySettingShowProducts = useQuery<
    AxiosResponse<Response.SettingShowProductsData>,
    AxiosError<any>
  >([API_KEY.SETTING_SHOW_PRODUCTS], quotation.getSettingShowProducts, {
    retry: 0,
    cacheTime: 0,
    onError(err) {
      console.log(err.response);
    },
  });

  return {
    querySettingShowProducts,
  };
};

export default useSettingShowProducts;
